import React from 'react';
import { useSelector } from 'react-redux'
import HrbTranslate from '../../components/language/HrbTranslate';
import TranslatableLink from '../../components/language/TranslatableLink';
import Section from '../../components/layout/Section';
import ContentCard from '../../components/layout/ContentCard';
import ContentPlain from '../../components/layout/ContentPlain';
import './HomePage.scss'

const HomePage = props => {

    const firstName = useSelector(state => state.accountData.firstName || 'Friend')

    return (
        <div className="content-grid">
            <Section sectionId='section-greeting' className='white'>
                <ContentPlain elementId='content-greeting'>
                    <h1 style={{ marginBottom: 40 }}>
                        <HrbTranslate text='HomePage.Labels.Hello' params={{ FirstName: firstName }} />
                    </h1>
                    <p className='p1'>
                        <HrbTranslate text='HomePage.Labels.Greeting' />
                        <TranslatableLink elementId='link-survey' linkKey='HomePage.Labels.Greeting.LinkUrl'>
                            <HrbTranslate text='HomePage.Labels.Greeting.LinkText' />
                        </TranslatableLink>
                    </p>
                </ContentPlain>
            </Section>
            <Section sectionId='section-info' className='light-functional-grey'>                
                <ContentCard elementId='quick-links' titleKey='HomePage.Labels.QuickLinks'>
                    <div className='columns'>
                        <div className='column is-3 is-offset-1'>
                            <p className='p1'><HrbTranslate text='HomePage.QuickLinksLabels.ImportantDates' /></p>
                            <TranslatableLink elementId='link-govtdates' linkKey='Links.Urls.GovtDates'>
                                <HrbTranslate text='Links.Labels.GovtDates' />
                            </TranslatableLink>
                            <TranslatableLink elementId='link-blockdates' linkKey='Links.Urls.BlockDates'>
                                <HrbTranslate text='Links.Labels.BlockDates' />
                            </TranslatableLink>
                        </div>
                        <div className='column is-2'>
                            <p className='p1'><HrbTranslate text='HomePage.QuickLinksLabels.HRBlock' /></p>
                            <TranslatableLink elementId='link-hrblock' linkKey='Links.Urls.HRBlockWebsite'>
                                <HrbTranslate text='Links.Labels.HRBlockWebsite' />
                            </TranslatableLink>
                            <TranslatableLink elementId='link-locator' linkKey='Links.Urls.HRBlockOfficeLocator'>
                                <HrbTranslate text='Links.Labels.HRBlockOfficeLocator' />
                            </TranslatableLink>
                            <TranslatableLink elementId='link-onlinehelp' linkKey='Links.Urls.OnlineHelp'>
                                <HrbTranslate text='Links.Labels.OnlineHelp' />
                            </TranslatableLink>
                        </div>
                        <div className='column is-2'>
                            <p className='p1'><HrbTranslate text='HomePage.QuickLinksLabels.ServiceNow' /></p>
                            <TranslatableLink elementId='link-servicenow-incidents' linkKey='Links.Urls.ServiceNowClientIncidents'>
                                <HrbTranslate text='Links.Labels.ServiceNowClientIncidents' />
                            </TranslatableLink>
                            <TranslatableLink elementId='link-servicenow-kb' linkKey='Links.Urls.ServiceNowKnowledgeBase'>
                                <HrbTranslate text='Links.Labels.ServiceNowKnowledgeBase' />
                            </TranslatableLink>
                        </div>
                        <div className='column is-3'>
                            <p className='p1'><HrbTranslate text='HomePage.QuickLinksLabels.BenefitsCalendar' /></p>
                            <TranslatableLink elementId='link-cra-benefits' linkKey='Links.Urls.BenefitsCalendarCraBenefitsPayments'>
                                <HrbTranslate text='Links.Labels.BenefitsCalendarCraBenefitsPayments' />
                            </TranslatableLink>
                            <TranslatableLink elementId='link-benefits-calendar' linkKey='Links.Urls.BenefitsCalendarSolidarity'>
                                <HrbTranslate text='Links.Labels.BenefitsCalendarSolidarity' />
                            </TranslatableLink>
                        </div>
                    </div>
                </ContentCard>
            </Section>
        </div>
    );
}

export default HomePage